// composables/useEditarSeguimiento.js
// Lógica de edición parcial (PATCH) para Brenda:
// fecha_compromiso, estatus_almacen, notas

import { ref } from "vue"
import Swal from "sweetalert2"
import { actualizarSeguimientoPedido } from "@/utils/api_backend"

export const ESTATUS_ALMACEN_OPCIONES = [
  "En proceso",
  "Listo para entrega",
  "Entregado",
  // "Cancelado",
]

export function useEditarSeguimiento() {
  const pedidoActual = ref(null)
  const guardando    = ref(false)

  const form = ref({
    fecha_compromiso:   "",
    fecha_entrega_real: "",
    estatus_almacen:    "",
    notas:              "",
  })

  function cargar(pedido) {
    pedidoActual.value = pedido
    form.value = {
      fecha_compromiso:   pedido.fecha_compromiso   || "",
      fecha_entrega_real: pedido.fecha_entrega_real || "",
      estatus_almacen:    pedido.estatus_almacen    || "En proceso",
      notas:              pedido.notas              || "",
    }
  }

  function reset() {
    pedidoActual.value = null
    guardando.value    = false
    form.value = {
      fecha_compromiso:   "",
      fecha_entrega_real: "",
      estatus_almacen:    "",
      notas:              "",
    }
  }

  async function guardar(onExito) {
    if (!pedidoActual.value) return

    // No se puede marcar un pedido como Entregado sin fecha compromiso:
    // sin ella no hay contra qué medir si la entrega fue en tiempo.
    // Solo aplica al momento de marcarlo; un pedido que YA estaba entregado
    // se edita en modo solo-notas y ahí el campo ni siquiera se muestra.
    const yaEstabaEntregado = pedidoActual.value.estatus_almacen === "Entregado"
    if (
      !yaEstabaEntregado &&
      form.value.estatus_almacen === "Entregado" &&
      !form.value.fecha_compromiso
    ) {
      Swal.fire({
        icon: "warning",
        title: "Falta la fecha compromiso",
        text: "Captura la fecha compromiso antes de marcar el pedido como entregado.",
      })
      return
    }

    guardando.value = true
    try {
      // PATCH parcial: solo se mandan las fechas que tienen valor.
      // Mandarlas en null las borraba en BD, y el modelo repone
      // fecha_entrega_real con la fecha de hoy al guardar un Entregado.
      const payload = {
        estatus_almacen: form.value.estatus_almacen,
        notas:           form.value.notas || "",
      }
      if (form.value.fecha_compromiso) {
        payload.fecha_compromiso = form.value.fecha_compromiso
      }
      if (form.value.fecha_entrega_real) {
        payload.fecha_entrega_real = form.value.fecha_entrega_real
      } else if (form.value.estatus_almacen !== "Entregado") {
        // Se quitó el estatus Entregado: sí hay que limpiar la fecha real
        payload.fecha_entrega_real = null
      }

      await actualizarSeguimientoPedido(pedidoActual.value.numero_pedido, payload)

      Swal.fire({
        icon: "success",
        title: "Pedido actualizado",
        text: `Pedido #${pedidoActual.value.numero_pedido} guardado correctamente.`,
        timer: 2000,
        showConfirmButton: false,
      })

      onExito?.()
    } catch (err) {
      console.error(err)
      Swal.fire("Error", "No se pudo actualizar el pedido.", "error")
    } finally {
      guardando.value = false
    }
  }

  return {
    pedidoActual,
    form,
    guardando,
    cargar,
    reset,
    guardar,
    ESTATUS_ALMACEN_OPCIONES,
  }
}